import { Button, Col, Modal, Row, Select } from "antd";
// import { useState } from "react";

const AssignTypeModal = ({
  assignTypeModal = false,
  setAssignTypeModal,
  setSystemMessageModal,
  setServiceType,
  handleSubmit,
}) => {
  // const [loading, setLoading] = useState(false);
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setServiceType(value);
  };
  return (
    <div>
      <Modal
        centered
        open={assignTypeModal}
        footer={null}
        onCancel={() => setAssignTypeModal(false)}
      >
        <div className=" justify-center items-center bg-white desktop:py-4">
          <h3 className="font-tavi text-2xl text-customBlack max-desktop:text-xl max-sm:text-lg text-center my-8 font-semibold">
            Assign service type to the car
          </h3>

          <Row justify="center" gutter={[32, 0]}>
            <Col xs={24} className="">
              <p className="font-euclid text-sm text-[#34324B]">Service Type</p>
              {/* <Form.Item
                  name="serviceType"
                  label={
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select service type!",
                    },
                  ]}
                > */}
              <Select
                placeholder="Select"
                className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                onChange={handleChange}
                options={[
                  {
                    label: (
                      <span className="font-euclid text-sm text-black">
                        Black Luxury
                      </span>
                    ),
                    value: "Black",
                  },
                  {
                    label: (
                      <span className="font-euclid text-sm text-black">
                        Ultra Luxury
                      </span>
                    ),
                    value: "Ultra",
                  },
                  {
                    label: (
                      <span className="font-euclid text-sm text-black">
                        Ultra Beyond Luxury
                      </span>
                    ),
                    value: "Ultra Beyond",
                  },
                  {
                    label: (
                      <span className="font-euclid text-sm text-black">
                        SUV Luxury
                      </span>
                    ),
                    value: "Suv",
                  },
                  {
                    label: (
                      <span className="font-euclid text-sm text-black">
                        Sprinter
                      </span>
                    ),
                    value: "Sprinter",
                  },
                ]}
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col lg={12}>
              <Button
                htmlType="submit"
                className="uppercase bg-button text-black rounded-lg text-sm font-bold max-2xl:text-xs mt-4 w-40 2xl:w-52 h-12 2xl:h-16"
                onClick={() => {
                  handleSubmit("ACTIVE");
                }}
              >
                {/* {loading ? "LOADING..." : "assign & approve"} */}
                assign & approve
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
        </div>
      </Modal>
    </div>
  );
};

export default AssignTypeModal;
